import { api } from '@/lib/api'
import { Notification } from '@/types'

export interface GetNotificationsParams {
  type?: 'info' | 'success' | 'warning' | 'error' | 'session' | 'message' | 'review'
  isRead?: boolean
  page?: number
  limit?: number
}

export interface NotificationResponse {
  notifications: Notification[]
  total: number
  unreadCount: number
  page: number
  limit: number
}

// Get user notifications
export const getNotifications = async (
  userId: string,
  params?: GetNotificationsParams
): Promise<Notification[]> => {
  return api.get(`/notifications/${userId}`, params)
}

// Mark notification as read
export const markNotificationAsRead = async (notificationId: string): Promise<void> => {
  return api.patch<void>(`/notifications/${notificationId}/read`)
}

// Mark all notifications as read
export const markAllNotificationsAsRead = async (userId: string): Promise<void> => {
  return api.patch<void>(`/notifications/${userId}/read-all`)
}

// Delete notification
export const deleteNotification = async (notificationId: string): Promise<void> => {
  return api.delete<void>(`/notifications/${notificationId}`)
}

// Get unread notification count
export const getUnreadNotificationCount = async (userId: string): Promise<{ count: number }> => {
  return api.get(`/notifications/${userId}/unread-count`)
}